const SET_SHELTERT_NAME = 'SET_SHELTERT_NAME';
const SET_ENTRY_KUBUN = 'SET_ENTRY_KUBUN';

export default {
  SET_SHELTERT_NAME,
  SET_ENTRY_KUBUN
};
